import { Route, RouterModule } from '@angular/router';

import { AccesoComponent } from './secciones/acceso/acceso.component';
import { ActivacionComponent } from './secciones/activacion/activacion.component';
import { AuthGuard } from './servicios/seguridad';
import { AvisoPrivacidadComponent } from './secciones/aviso-privacidad/aviso-privacidad.component';
import { AyudaComponent } from './secciones/ayuda/ayuda.component';
import { CambioContrasenaComponent } from './secciones/cambio-contrasena/cambio-contrasena.component';
import { CarritoComponent } from './secciones/carrito/carrito.component';
import { CitasComponent } from './secciones/citas/citas.component';
import { ComoComprarComponent } from './secciones/como-comprar/como-comprar.component';
import { ContactoFormComponent } from './secciones/contacto-form/contacto-form.component';
import { DetallePedidoComponent } from './secciones/detalle-pedido/detalle-pedido.component';
import { HomeComponent } from './secciones/home/home.component';
import { MiCuentaComponent } from './secciones/mi-cuenta/mi-cuenta.component';
import { NewsletterComponent } from './secciones/newsletter/newsletter.component';
import { NgModule } from '@angular/core';
import { NoPageComponent } from './secciones/no-page/no-page.component';
import { NosotrosComponent } from './secciones/nosotros/nosotros.component';
import { ProductoComponent } from './secciones/producto/producto.component';
import { RecuperacionComponent } from './secciones/recuperacion/recuperacion.component';
import { RegistroComponent } from './secciones/registro/registro.component';
import { TerminosCondicionesComponent } from './secciones/terminos-condiciones/terminos-condiciones.component';
import { TiendaComponent } from './secciones/tienda/tienda.component';
import { UbicacionesComponent } from './secciones/ubicaciones/ubicaciones.component';

export const app_routes: Route[] = [
	{ path: '', component: HomeComponent, data: { title: { text: 'Home' }} },
	{ path: 'nosotros', component: NosotrosComponent, data: { title: { text: 'Nosotros' }} },
	// { path: 'citas', component: CitasComponent, data: { title: { text: 'Citas' }} },
	{ path: 'ubicaciones', component: UbicacionesComponent, data: { title: { text: 'Ubicaciones' }} },
	{ path: 'tienda', component: TiendaComponent, data: { title: { text: 'Tienda' }} },
	{ path: 'aviso-privacidad', component: AvisoPrivacidadComponent, data: { title: { text: 'Aviso de privacidad' }} },
	{ path: 'terminos-condiciones', component: TerminosCondicionesComponent, data: { title: { text: 'Términos y condiciones' }} },

	{ path: 'newsletter', component: NewsletterComponent, data:{action:1, title: { text: 'Newsletter' }} },
    { path: 'desuscripcion', component: NewsletterComponent, data:{action:2, title: { text: 'Desuscripción' }} },
    { path: 'acceso', component: AccesoComponent, data: { title: { text: 'Acceso' }} },
    { path: 'registro', component: RegistroComponent, data: { title: { text: 'Registro' }} },
    { path: 'recuperacion', component: RecuperacionComponent, data: { title: { text: 'Recuperación' }} },
    { path: 'activacion/:cuenta', component: ActivacionComponent, data: { title: { text: 'Activación' }} },
    { path: 'producto/:alias', component: ProductoComponent, data: { title: { text: 'Producto' }} },
    { path: 'carrito', component: CarritoComponent, data: { title: { text: 'Carrito' }} },
    { path: "cambio/:uuid", component: CambioContrasenaComponent, data: { title: { text: 'Cambio de contraseña' }} },

    { path:"mi-cuenta", component: MiCuentaComponent, data:{ action:1, title: { text: 'Mi cuenta' } }, canActivate: [AuthGuard] },
    { path:"mi-cuenta/mis-direcciones", component: MiCuentaComponent, data:{ action:2, title: { text: 'Mis Direcciones' } }, canActivate: [AuthGuard] },
    { path:"mi-cuenta/mis-pedidos", component: MiCuentaComponent, data:{ action:3, title: { text: 'Mis Pedidos' } }, canActivate: [AuthGuard] },
    { path:"mi-cuenta/mis-favoritos", component: MiCuentaComponent, data:{ action:4, title: { text: 'Mis Favoritos' } }, canActivate: [AuthGuard] },
    { path:"mi-cuenta/pedido/:uuid", component: DetallePedidoComponent, canActivate: [AuthGuard], data: { title: { text: 'Detalle de pedido' }} },
    
    { path: 'ayuda', component: AyudaComponent, data: { title: { text: 'Ayuda' }} },
    { path: 'contacto', component: ContactoFormComponent, data: { title: { text: 'Contacto' }} },
    { path: 'como-comprar', component: ComoComprarComponent, data: { title: { text: 'Como comprar' }} },

    { path:'404', component:NoPageComponent, data: { title: { text: 'No encontrado' }} },

    { path: ':aliasMarca', component: TiendaComponent },

    { path: '**', redirectTo:"/404" }
];

export const APP_ROUTING = RouterModule.forRoot(app_routes, {
    initialNavigation: 'enabled',
    scrollPositionRestoration: 'top'
});



